var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.4181 15.0435H16.3676L15.9952 14.6844C17.2984 13.1685 18.083 11.2004 18.083 9.05949C18.083 4.28563 14.2134 0.416 9.43948 0.416C4.66562 0.416 0.79599 4.28563 0.79599 9.05949C0.79599 13.8334 4.66562 17.703 9.43948 17.703C11.5804 17.703 13.5485 16.9184 15.0644 15.6153L15.4234 15.9876V17.0381L22.0723 23.6737L24.0536 21.6923L17.4181 15.0435ZM9.43948 15.0435C6.12836 15.0435 3.45553 12.3706 3.45553 9.05949C3.45553 5.74837 6.12836 3.07554 9.43948 3.07554C12.7506 3.07554 15.4234 5.74837 15.4234 9.05949C15.4234 12.3706 12.7506 15.0435 9.43948 15.0435Z","fill":"currentColor"}));
}

Search.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Search;

Search.default = Search;
